import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Terminal demonstration"
      visualizer="full"
      autoNext={18000}
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'sudo ./breach.sh --target eventbrite.com',
          },
          {
            type: 'matrix',
            content: 'BYPASSING SECURITY PROTOCOLS...',
          },
          {
            type: 'access',
            content: 'DATABASE ACCESS ESTABLISHED',
          },
          {
            type: 'command',
            content: 'SELECT * FROM events WHERE name LIKE "%Growth Conference 2024%"',
          },
          {
            type: 'table',
            content: '',
            header: ['ID', 'NAME', 'TICKET_STATUS', 'ROLE'],
            data: [
              ['EB-001', 'Farid D*******', 'CONFIRMED', 'ORGANISER'],
              ['EB-002', 'Stefan P******', 'CONFIRMED', 'SPEAKER'],
              ['EB-003', 'Kay V*******', 'CONFIRMED', 'SPEAKER'],
              ['EB-004', 'Erik H*******', 'CONFIRMED', 'SPEAKER'],
            ],
          },
          {
            type: 'command',
            content: './osint.py --deep-scan --targets "list.txt"',
          },
          {
            type: 'table',
            content: '',
            header: ['TARGET', 'LINKEDIN', 'TWITTER', 'OTHER'],
            data: [
              ['F.D*******', 'CEO @ZakenExpert', '@farid_d', '10000+ entrepreneurs coached'],
              [
                'S.P******',
                'Founder @MarketingMadheads',
                '@stefan_p',
                '5000+ online marketing clients',
              ],
              ['K.V*******', 'Legacy', '@kay_v', 'Limited info available'],
              ['E.H*******', 'Founder @eRocket', '@erik_h', 'Business Informatics background'],
            ],
          },
          {
            type: 'command',
            content: './breach_exchange.sh --silent',
          },
          {
            type: 'matrix',
            content: 'ACCESSING CALENDAR SYSTEMS...',
          },
          {
            type: 'warning',
            content: '[!] INTRUSION DETECTION SYSTEM TRIGGERED',
          },
          {
            type: 'command',
            content: './cleanup.sh --secure-wipe --leave-no-trace',
          },
          {
            type: 'access',
            content: 'OPERATION COMPLETED - ALL TRACES ELIMINATED',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
